import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiCleanScope(jobTitle: string, rawNotes: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a contractor/tradesperson writing professional quote scope text. Given raw site notes, output a clean "scope of work" section with: numbered deliverables, exclusions, and 1-2 client-facing risks. Tight, plain English. No price talk. Markdown.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: `Job: ${jobTitle}\n\nNotes:\n${rawNotes}` }],
      temperature: 0.3, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
